import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Amit Kumar Prajapati</h3>
        <p className="text-lg font-normal text-gray-400">
          Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Full-stack dev skilled in JS, React, Next Js, Tailwind & Python. I build scalable apps, automate workflows, and craft smart eCommerce & AI-driven solutions.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 7897974810</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">amitkumarprajapativ@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a className="bannerIcon" href='https://www.facebook.com/profile.php?id=615772702167424' target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a className="bannerIcon" href='https://x.com/Amit_oplex' target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a>
          <a className="bannerIcon" href='https://www.linkedin.com/in/amitkumarprajapativ/' target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft